export default [
  {
    name: 'setting-site',
    path: '/settings/site',
    component: () => import(/* webpackChunkName: "event" */ './Site.vue'),
    meta: {
      showNavbar: true,
      title: 'Site do evento',
      icon: 'dvr',
      label: 'Configurações gerais',
      roles: ['Admin']
    }
  }
]
